export default "__VITE_ASSET__DtPl8Xn3__"